import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@nrwl/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Notification } from '../../../../../models/users/notification';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getUserProfile(id: any) {
    if (!id.payload) {
      id = localStorage.getItem('rxphoto.user');
    } else {
      id = id.payload;
    }

    return this.http.get(environment.baseAPIUrlv3 + `doctor/${id}/`);
  }

  getLocations(data: any) {
    return this.http.get(environment.baseAPIUrlv3 + `doctor/${data.id}/locations/`);
  }

  editUser(data: any) {
    return this.http.patch(environment.baseAPIUrlv3 + `doctor/${data.id}/`, data.payload);
  }

  uploadUserFoto(data: any) {
    return this.http.post(environment.baseAPIUrlv3 + `doctor/${data.id}/set-photo/`, data.payload);
  }

  removeUserFoto(data: any) {
    return this.http.post(environment.baseAPIUrlv3 + `doctor/${data.id}/clear-photo/`, null);
  }

  changeUserPassword(data: any) {
    return this.http.post(
      environment.baseAPIUrlv3 + `doctor/${data.id}/set-password/`,
      data.payload,
    );
  }

  checkUserPassword(doctorId, data: any) {
    return this.http.post(environment.baseAPIUrlv3 + `doctor/${doctorId}/check-password/`, data);
  }

  getUserEventNotifications(): Observable<any> {
    return this.http.get(environment.baseAPIUrlv3 + `notification/?limit=30&type=0,1,3,4,5`).pipe(
      map((res: any) => {
        res.results = res.results.map((n) => new Notification(n));
        return res;
      }),
    );
  }

  getUserMessageNotifications(): Observable<any> {
    return this.http.get(environment.baseAPIUrlv3 + `notification/?limit=30&type=2`).pipe(
      map((res: any) => {
        res.results = res.results.map((n) => new Notification(n));
        return res;
      }),
    );
  }

  getUserNotificationsBase(queryParamsObject: any = {}): Observable<any> {
    const params = new HttpParams({
      fromObject: queryParamsObject,
    });

    return this.http.get(environment.baseAPIUrlv3 + `notification`, {
      params,
    });
    // .pipe(
    //     map((res:any) => {
    //         res.results = res.results.map(n => new Notification(n))
    //         return res;
    //     })
    // );
  }

  getMoreNotifications(next): Observable<any> {
    return this.http.get(next).pipe(
      map((res: any) => {
        res.results = res.results.map((n) => new Notification(n));
        return res;
      }),
    );
  }

  readBulkNotification(ids): Observable<any> {
    const params: HttpParams = new HttpParams().append('ids', ids);
    return this.http.get(environment.baseAPIUrlv3 + `notification/bulk/read/`, { params });
  }

  readAllNotification(): Observable<any> {
    return this.http.get(environment.baseAPIUrlv3 + `notification/bulk/read-all/`);
  }

  getNotificationAmount(): Observable<any> {
    return this.http.get(environment.baseAPIUrlv3 + 'notification/message_count/');
  }

  readNotification(id): Observable<any> {
    return this.http.get(environment.baseAPIUrlv3 + `notification/${id}/read/`);
  }
}
